import BaseAPI from './base.api';
import { checkAndReturnCachedData } from './utils/utils';

export default class EpirocMainPageAPI extends BaseAPI {
  getAssetTimeline = async (startDate: string, endDate: string) => {
    const response = await this.API.post('glencore/getAssetTimeline', {
      startDate,
      endDate,
    });
    return response.data.Items;
  };

  getShiftWiseDistanceTravelled = async (
    startDate: string,
    endDate: string
  ) => {
    const response = await this.API.post(
      'glencore/getShiftWiseDistanceTravelled',
      {
        startDate,
        endDate,
      }
    );
    return response.data.Items;
  };

  getLocationTimeline = async (startDate: string, endDate: string) => {
    const response = await this.API.post('glencore/getLocationTimeline', {
      startDate,
      endDate,
    });
    return response.data.Items;
  };

  getEventsInsightsWrtAssetLocationTimestamps = async ({
    startDate,
    endDate,
    assetBase,
    location,
  }: {
    startDate: string;
    endDate: string;
    assetBase: string;
    location: string;
  }) => {
    const response = await this.API.post(
      'glencore/getEventsInsightsWrtAssetLocationTimestamps',
      {
        startDate,
        endDate,
        assetBase,
        location,
      }
    );
    return response.data.Items;
  };
}
